import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminThemeContext = createContext(null);

export function AdminThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('admin_theme') || 'dark');

  useEffect(() => {
    localStorage.setItem('admin_theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');
  const isDark = theme === 'dark';

  const colors = isDark ? {
    bg: '#0a0e1a',
    sidebar: '#0a0e1a',
    sidebarBorder: '#1e293b',
    card: 'rgba(30,41,59,0.5)',
    cardBorder: 'rgba(51,65,85,0.4)',
    input: 'rgba(15,23,42,0.5)',
    inputBorder: 'rgba(71,85,105,0.5)',
    text: '#ffffff',
    textSecondary: '#94a3b8',
    textMuted: '#64748b',
    accent: '#6366f1',
    mainBg: '#0a0e1a',
  } : {
    bg: '#f8fafc',
    sidebar: '#ffffff',
    sidebarBorder: '#e2e8f0',
    card: '#ffffff',
    cardBorder: '#e2e8f0',
    input: '#f1f5f9',
    inputBorder: '#cbd5e1',
    text: '#0f172a',
    textSecondary: '#475569',
    textMuted: '#94a3b8',
    accent: '#4f46e5',
    mainBg: '#f1f5f9',
  };

  return (
    <AdminThemeContext.Provider value={{ theme, toggleTheme, isDark, colors }}>
      {children}
    </AdminThemeContext.Provider>
  );
}

export function useAdminTheme() {
  const ctx = useContext(AdminThemeContext);
  if (!ctx) return { theme: 'dark', isDark: true, toggleTheme: () => {}, colors: {} };
  return ctx;
}
